import { Button, makeStyles } from "@material-ui/core";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { PaymentService } from "./services/PaymentService";
import React from "react";
import { useParams } from "react-router-dom";
import { ITransactionReq } from "../../../utils/PaymentInterfaces";
import { transactionReqDefaultValue } from "../../../utils/defaultNullValues";
import { Link } from "react-router-dom";
import {
    dateToStringDDMMYYYY,
    getDayNumber,
    getDayNumberProm,
    getPlacementAdsLabel,
} from "../../../utils/App";
import moment from "moment";
import { RouteAdminUser } from "../../Admin/constant/routesName";
import { PropagateLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { CurrencyContext } from "../../../contexts/AppContext";
import { useContext } from "react";
import { ConvertedDeviseWithoutMoneySign } from "../../../utils/CurrencyConvertFunction";
import { EPaymentMethod } from "../../../utils/enum/PaymentMethod";

const useStyles = makeStyles(() => ({
    success: {
        display: "flex",
        justifyContent: "center",
        marginTop: 50,
    },
    icon: {
        color: "green",
        fontSize: "50px !important",
    },

    span: {
        fontSize: 50,
    },
    text: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    loading: {
        width: "100%",
        position: "absolute",
        top: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        left: 0,
    },
    spanNext: {
        fontSize: 14,
        marginBottom: 20,
    },
    go: {
        fontSize: 14,
        fontFamily: "Josefin Sans",
        color: "#FFFFFF",
        textTransform: "capitalize",
        textAlign: "center",
        padding: "8px 14px",
        borderRadius: 100,
        background: "#890608",
        marginTop: 20,
        "&:hover": {
            background: "#B5551B",
        },
    },
    linkContainerButton: {
        textDecoration: "none",
    },
    flex: {
        display: "flex",
        flexDirection: "column",
        marginTop: 20,
    },
}));
const paymentService = new PaymentService();
export const PaymentSuccess = () => {
    const classes = useStyles();
    const [loadingPage, setLoadingPage] = React.useState<boolean>(true);
    const [transaction, setTransaction] = React.useState<ITransactionReq>(
        transactionReqDefaultValue
    );
    const params: { id: string } = useParams();
    //console.log('Route Params:', params);
    const currencyContext = useContext(CurrencyContext);
    const [, setCommissionFee] = React.useState<number>(0);
    const [priceConvertedFinal, setPriceConvertedFinal] =
        React.useState<number>(0);
    const { currency } = currencyContext;
    const { t } = useTranslation();

    React.useEffect(() => {

        if (!params.id) {
            console.error('PaymentSuccess error: ID parameter is missing');
            setLoadingPage(false);
            return;
        }
        
        paymentService
            .getTransactionById(params.id)
            .then((response) => {
                if (response.success) {
                    let transaction = response.data;
                    setTransaction(transaction);
                    if (
                        transaction.reservation.announce?.property?.type
                            .name === "Hôtel"
                    ) {
                        paymentService
                            .getSpecialFeeByPropertyType(
                                transaction.reservation.announce?.property?.type
                                    .name
                            )
                            .then((respCom) => {
                                if (respCom.success) {
                                    const percentage = respCom.data
                                        ? respCom.data.percentageTraveller
                                        : 0;
                                    setCommissionFee(percentage);

                                    let priceWithDaysWithCleanningAndCmomission: number;

                                    if (
                                        transaction.reservation.announce
                                            .promotion
                                    ) {
                                        let nbjours_prom = getDayNumberProm(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation
                                                .dateCheckOut,
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.startDate
                                            ).format("YYYY/MM/DD"),
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.endDate
                                            ).format("YYYY/MM/DD"),
                                            transaction.reservation.announce
                                                .price,
                                            transaction.reservation.announce
                                                .promotion.price
                                        ).DateProm;
                                        let nbjours_simple = getDayNumberProm(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation
                                                .dateCheckOut,
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.startDate
                                            ).format("YYYY/MM/DD"),
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.endDate
                                            ).format("YYYY/MM/DD"),
                                            transaction.reservation.announce
                                                .price,
                                            transaction.reservation.announce
                                                .promotion.price
                                        ).DateSimple;
                                        let priceNormal;
                                        if (
                                            nbjours_simple >= 7 &&
                                            nbjours_simple < 14 &&
                                            transaction.reservation.announce
                                                .priceWeekly &&
                                            transaction.reservation.announce
                                                .priceWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceWeekly /
                                                    7 +
                                                (transaction.reservation
                                                    .announce.priceWeekly /
                                                    7) *
                                                    (percentage / 100);
                                        } else if (
                                            nbjours_simple >= 14 &&
                                            nbjours_simple < 30 &&
                                            transaction.reservation.announce
                                                .priceBiWeekly &&
                                            transaction.reservation.announce
                                                .priceBiWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceBiWeekly /
                                                    14 +
                                                (transaction.reservation
                                                    .announce.priceBiWeekly /
                                                    14) *
                                                    (percentage / 100);
                                        } else if (
                                            nbjours_simple >= 30 &&
                                            transaction.reservation.announce
                                                .priceMonthly &&
                                            transaction.reservation.announce
                                                .priceMonthly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceMonthly /
                                                    30 +
                                                (transaction.reservation
                                                    .announce.priceMonthly /
                                                    30) *
                                                    (percentage / 100);
                                        } else {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .price +
                                                transaction.reservation.announce
                                                    .price *
                                                    (percentage / 100);
                                        }
                                        const priceProm =
                                            transaction.reservation.announce
                                                .promotion.price +
                                            transaction.reservation.announce
                                                .price *
                                                (percentage / 100);
                                        const priceWithDays =
                                            nbjours_simple * priceNormal +
                                            nbjours_prom * priceProm;
                                        priceWithDaysWithCleanningAndCmomission =
                                            priceWithDays +
                                            (transaction.reservation.announce
                                                .cleaningFees +
                                                transaction.reservation.announce
                                                    .cleaningFees *
                                                    (percentage / 100));
                                    } else {
                                        const jours = getDayNumber(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation.dateCheckOut
                                        );
                                        let priceNormal;
                                        if (
                                            jours >= 7 &&
                                            jours < 14 &&
                                            transaction.reservation.announce
                                                .priceWeekly &&
                                            transaction.reservation.announce
                                                .priceWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceWeekly /
                                                    7 +
                                                (transaction.reservation
                                                    .announce.priceWeekly /
                                                    7) *
                                                    (percentage / 100);
                                        } else if (
                                            jours >= 14 &&
                                            jours < 30 &&
                                            transaction.reservation.announce
                                                .priceBiWeekly &&
                                            transaction.reservation.announce
                                                .priceBiWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceBiWeekly /
                                                    14 +
                                                (transaction.reservation
                                                    .announce.priceBiWeekly /
                                                    14) *
                                                    (percentage / 100);
                                        } else if (
                                            jours >= 30 &&
                                            transaction.reservation.announce
                                                .priceMonthly &&
                                            transaction.reservation.announce
                                                .priceMonthly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceMonthly /
                                                    30 +
                                                (transaction.reservation
                                                    .announce.priceMonthly /
                                                    30) *
                                                    (percentage / 100);
                                        } else {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .price +
                                                transaction.reservation.announce
                                                    .price *
                                                    (percentage / 100);
                                        }
                                        const priceWithDays =
                                            priceNormal *
                                            getDayNumber(
                                                transaction.reservation
                                                    .dateCheckIn,
                                                transaction.reservation
                                                    .dateCheckOut
                                            );
                                        priceWithDaysWithCleanningAndCmomission =
                                            priceWithDays +
                                            (transaction.reservation.announce
                                                .cleaningFees +
                                                transaction.reservation.announce
                                                    .cleaningFees *
                                                    (percentage / 100));
                                    }

                                    const totalService =
                                        transaction.reservation.services
                                            .length > 0
                                            ? transaction.reservation.services.reduce(
                                                  (prev: any, service: any) =>
                                                      prev + service.price,
                                                  0
                                              )
                                            : 0;
                                    if (totalService > 0) {
                                        ConvertedDeviseWithoutMoneySign(
                                            "XAF",
                                            currency,
                                            totalService
                                        )
                                            .then(
                                                (
                                                    totalServiceConverted: any
                                                ): any => {
                                                    ConvertedDeviseWithoutMoneySign(
                                                        transaction.reservation
                                                            .announce.devise,
                                                        currency,
                                                        priceWithDaysWithCleanningAndCmomission
                                                    )
                                                        .then(
                                                            (value: any): any =>
                                                                setPriceConvertedFinal(
                                                                    Number(
                                                                        value
                                                                    ) +
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                )
                                                        )
                                                        .catch((error) =>
                                                            console.log(error)
                                                        );
                                                }
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    } else {
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            priceWithDaysWithCleanningAndCmomission
                                        )
                                            .then((value: any): any =>
                                                setPriceConvertedFinal(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    }
                                }
                            });
                    } else {
                        paymentService
                            .getCommissionFeeByCountryAndCityId(
                                transaction.reservation.announce?.property
                                    ?.address?.country?.name,
                                transaction.reservation.announce?.property
                                    ?.address?.city?.name
                            )
                            .then((respCom) => {
                               /* console.log("PaymentSuccess.tsx - paymentService.getCommissionFeeByCountryAndCityId arguments:", {
                                    countryName: transaction.reservation.announce?.property?.address?.country?.name,
                                    cityName: transaction.reservation.announce?.property?.address?.city?.name,
                                });*/
                                if (respCom.success) {
                                    const percentage = respCom.data
                                        ? respCom.data.percentage
                                        : 0;
                                    setCommissionFee(percentage);

                                    let priceWithDaysWithCleanningAndCmomission: number;

                                    if (
                                        transaction.reservation.announce
                                            .promotion
                                    ) {
                                        let nbjours_prom = getDayNumberProm(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation
                                                .dateCheckOut,
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.startDate
                                            ).format("YYYY/MM/DD"),
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.endDate
                                            ).format("YYYY/MM/DD"),
                                            transaction.reservation.announce
                                                .price,
                                            transaction.reservation.announce
                                                .promotion.price
                                        ).DateProm;
                                        let nbjours_simple = getDayNumberProm(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation
                                                .dateCheckOut,
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.startDate
                                            ).format("YYYY/MM/DD"),
                                            moment(
                                                transaction.reservation.announce
                                                    .promotion.endDate
                                            ).format("YYYY/MM/DD"),
                                            transaction.reservation.announce
                                                .price,
                                            transaction.reservation.announce
                                                .promotion.price
                                        ).DateSimple;
                                        let priceNormal;
                                        if (
                                            nbjours_simple >= 7 &&
                                            nbjours_simple < 14 &&
                                            transaction.reservation.announce
                                                .priceWeekly &&
                                            transaction.reservation.announce
                                                .priceWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceWeekly /
                                                    7 +
                                                (transaction.reservation
                                                    .announce.priceWeekly /
                                                    7) *
                                                    (percentage / 100);
                                        } else if (
                                            nbjours_simple >= 14 &&
                                            nbjours_simple < 30 &&
                                            transaction.reservation.announce
                                                .priceBiWeekly &&
                                            transaction.reservation.announce
                                                .priceBiWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceBiWeekly /
                                                    14 +
                                                (transaction.reservation
                                                    .announce.priceBiWeekly /
                                                    14) *
                                                    (percentage / 100);
                                        } else if (
                                            nbjours_simple >= 30 &&
                                            transaction.reservation.announce
                                                .priceMonthly &&
                                            transaction.reservation.announce
                                                .priceMonthly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceMonthly /
                                                    30 +
                                                (transaction.reservation
                                                    .announce.priceMonthly /
                                                    30) *
                                                    (percentage / 100);
                                        } else {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .price +
                                                transaction.reservation.announce
                                                    .price *
                                                    (percentage / 100);
                                        }
                                        const priceProm =
                                            transaction.reservation.announce
                                                .promotion.price +
                                            transaction.reservation.announce
                                                .price *
                                                (percentage / 100);
                                        const priceWithDays =
                                            nbjours_simple * priceNormal +
                                            nbjours_prom * priceProm;
                                        priceWithDaysWithCleanningAndCmomission =
                                            priceWithDays +
                                            (transaction.reservation.announce
                                                .cleaningFees +
                                                transaction.reservation.announce
                                                    .cleaningFees *
                                                    (percentage / 100));
                                    } else {
                                        const jours = getDayNumber(
                                            transaction.reservation.dateCheckIn,
                                            transaction.reservation.dateCheckOut
                                        );
                                        let priceNormal;
                                        if (
                                            jours >= 7 &&
                                            jours < 14 &&
                                            transaction.reservation.announce
                                                .priceWeekly &&
                                            transaction.reservation.announce
                                                .priceWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceWeekly /
                                                    7 +
                                                (transaction.reservation
                                                    .announce.priceWeekly /
                                                    7) *
                                                    (percentage / 100);
                                        } else if (
                                            jours >= 14 &&
                                            jours < 30 &&
                                            transaction.reservation.announce
                                                .priceBiWeekly &&
                                            transaction.reservation.announce
                                                .priceBiWeekly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceBiWeekly /
                                                    14 +
                                                (transaction.reservation
                                                    .announce.priceBiWeekly /
                                                    14) *
                                                    (percentage / 100);
                                        } else if (
                                            jours >= 30 &&
                                            transaction.reservation.announce
                                                .priceMonthly &&
                                            transaction.reservation.announce
                                                .priceMonthly > 0
                                        ) {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .priceMonthly /
                                                    30 +
                                                (transaction.reservation
                                                    .announce.priceMonthly /
                                                    30) *
                                                    (percentage / 100);
                                        } else {
                                            priceNormal =
                                                transaction.reservation.announce
                                                    .price +
                                                transaction.reservation.announce
                                                    .price *
                                                    (percentage / 100);
                                        }
                                        const priceWithDays =
                                            priceNormal *
                                            getDayNumber(
                                                transaction.reservation
                                                    .dateCheckIn,
                                                transaction.reservation
                                                    .dateCheckOut
                                            );
                                        priceWithDaysWithCleanningAndCmomission =
                                            priceWithDays +
                                            (transaction.reservation.announce
                                                .cleaningFees +
                                                transaction.reservation.announce
                                                    .cleaningFees *
                                                    (percentage / 100));
                                    }

                                    const totalService =
                                        transaction.reservation.services
                                            .length > 0
                                            ? transaction.reservation.services.reduce(
                                                  (prev: any, service: any) =>
                                                      prev + service.price,
                                                  0
                                              )
                                            : 0;
                                    if (totalService > 0) {
                                        ConvertedDeviseWithoutMoneySign(
                                            "XAF",
                                            currency,
                                            totalService
                                        )
                                            .then(
                                                (
                                                    totalServiceConverted: any
                                                ): any => {
                                                    ConvertedDeviseWithoutMoneySign(
                                                        transaction.reservation
                                                            .announce.devise,
                                                        currency,
                                                        priceWithDaysWithCleanningAndCmomission
                                                    )
                                                        .then(
                                                            (value: any): any =>
                                                                setPriceConvertedFinal(
                                                                    Number(
                                                                        value
                                                                    ) +
                                                                        Number(
                                                                            totalServiceConverted
                                                                        )
                                                                )
                                                        )
                                                        .catch((error) =>
                                                            console.log(error)
                                                        );
                                                }
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    } else {
                                        ConvertedDeviseWithoutMoneySign(
                                            transaction.reservation.announce
                                                .devise,
                                            currency,
                                            priceWithDaysWithCleanningAndCmomission
                                        )
                                            .then((value: any): any =>
                                                setPriceConvertedFinal(value)
                                            )
                                            .catch((error) =>
                                                console.log(error)
                                            );
                                    }
                                }
                            });
                    }
                }

                setLoadingPage(false);
            })
            .catch((error) => {
                setLoadingPage(false);
                //console.log("PaymentSuccess comp error", error);
            });
    }, [params.id, currency]);

    return (
        <div className={classes.success}>
            <div className={classes.text}>
                {loadingPage && (
                    <div className={classes.loading}>
                        <PropagateLoader color="#36D7B7" size={15} />
                    </div>
                )}
                {!loadingPage && (
                    <>
                        <span className={classes.span}>
                            {t("paiement.label.paiement-accepte")}
                        </span>

                        <CheckCircleIcon className={classes.icon} />
                        {transaction.reservation !== null && (
                            <>
                                <div className={classes.flex}>
                                    <span className={classes.spanNext}>
                                        {t(
                                            "paiement.label.reference-de-la-transaction"
                                        )}{" "}
                                        : {transaction._id}
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.logement")} :{" "}
                                        {transaction.reservation
                                            ? transaction.reservation.announce
                                                  .property.name
                                            : transaction.announceAd?.announce
                                                  .property.name}
                                    </span>
                                    <span className={classes.spanNext}>
                                        {transaction.reservation
                                            ? `${transaction.reservation.announce.property.address.city?.name} - ${transaction.reservation.announce.property.address.country?.name}`
                                            : `${transaction.announceAd?.announce.property.address.city?.name} ${transaction.announceAd?.announce.property.address.country?.name}`}
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.date")} :{" "}
                                        {t("paiement.label.du")}{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {dateToStringDDMMYYYY(
                                                new Date(
                                                    transaction.reservation.dateCheckIn
                                                )
                                            )}{" "}
                                        </span>{" "}
                                        {t("paiement.label.au")}{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {dateToStringDDMMYYYY(
                                                new Date(
                                                    transaction.reservation.dateCheckOut
                                                )
                                            )}{" "}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t(
                                            "paiement.label.nombre-de-personnes"
                                        )}{" "}
                                        :
                                        {transaction.reservation
                                            .travellerAdultTotal ? (
                                            <span style={{ color: "#B5551B" }}>
                                                {" "}
                                                {
                                                    transaction.reservation
                                                        .travellerAdultTotal
                                                }{" "}
                                                {t("paiement.label.adultes")}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {transaction.reservation
                                            .travellerAdultTotal &&
                                        transaction.reservation
                                            .travellerChildTotal ? (
                                            <span>
                                                {" "}
                                                {t("paiement.label.et")}{" "}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                        {transaction.reservation
                                            .travellerChildTotal ? (
                                            <span style={{ color: "#B5551B" }}>
                                                {" "}
                                                {
                                                    transaction.reservation
                                                        .travellerChildTotal
                                                }{" "}
                                                {t("paiement.label.enfants")}
                                            </span>
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.montant-regle")} :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {priceConvertedFinal} {currency}{" "}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t(
                                            "paiement.label.methode-de-paiement"
                                        )}{" "}
                                        :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {transaction.method ===
                                            EPaymentMethod.Paypal
                                                ? EPaymentMethod.Paypal
                                                : transaction.method ===
                                                  EPaymentMethod.Credit
                                                ? EPaymentMethod.Credit
                                                : "Mobile Money"}{" "}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}></span>
                                    <span className={classes.spanNext}>
                                        {t(
                                            "paiement.label.merci-pour-votre-requete"
                                        )}
                                    </span>
                                </div>
                                <Link
                                    to={`${RouteAdminUser.BOOKING}`}
                                    className={classes.linkContainerButton}
                                >
                                    <Button className={classes.go}>
                                        {t(
                                            "paiement.label.voir-mes-reservations"
                                        )}
                                    </Button>
                                </Link>
                            </>
                        )}
                        {transaction.announceAd !== null && (
                            <>
                                <div className={classes.flex}>
                                    <span className={classes.spanNext}>
                                        {t(
                                            "paiement.label.reference-de-la-transaction"
                                        )}{" "}
                                        :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {transaction._id}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.annonce-boostee")} :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {
                                                transaction.announceAd.announce
                                                    .property.name
                                            }
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.emplacement")} :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {getPlacementAdsLabel(
                                                transaction.announceAd.adParam
                                                    .placement
                                            )}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.pour-une-duree-de")}{" "}
                                        :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {
                                                transaction.announceAd.adParam
                                                    .duration
                                            }{" "}
                                            {t("paiement.label.semaines")}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t("paiement.label.date-d-echeance")} :{" "}
                                        {t("paiement.label.du")}{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {transaction.announceAd.startAt
                                                ? dateToStringDDMMYYYY(
                                                      moment(
                                                          transaction.announceAd
                                                              .startAt
                                                      ).toDate()
                                                  )
                                                : dateToStringDDMMYYYY(
                                                      new Date()
                                                  )}{" "}
                                        </span>{" "}
                                        {t("paiement.label.au")}{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {moment(
                                                transaction.announceAd.startAt
                                                    ? transaction.announceAd
                                                          .startAt
                                                    : new Date()
                                            )
                                                .add(
                                                    transaction.announceAd
                                                        .adParam.duration,
                                                    "weeks"
                                                )
                                                .format("DD/MM/YYYY")}{" "}
                                        </span>
                                    </span>
                                    <span className={classes.spanNext}>
                                        {t(
                                            "paiement.label.methode-de-paiement"
                                        )}{" "}
                                        :{" "}
                                        <span style={{ color: "#B5551B" }}>
                                            {" "}
                                            {transaction.method}{" "}
                                        </span>
                                    </span>
                                </div>
                                <Link
                                    to={`${RouteAdminUser.ANNOUNCES_ADS}`}
                                    className={classes.linkContainerButton}
                                >
                                    <Button className={classes.go}>
                                        {t(
                                            "paiement.label.voir-mes-annonces-boostesSee"
                                        )}
                                    </Button>
                                </Link>
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
